import script from "./Players.vue?vue&type=script&setup=true&lang=js"
export * from "./Players.vue?vue&type=script&setup=true&lang=js"

import "./Players.vue?vue&type=style&index=0&id=b6f8dd3c&lang=css"

const __exports__ = script;

export default __exports__